import { useState, useEffect } from 'react';
import './tab.scss';

// 适配移动端
import '../../../phone/appointmentManagement/compentent/tab/tab.scss';
interface TabItem {
    id: number | string;
    name: string;
    time?: string;
    hidden?: boolean;
}
interface TabProps {
    tabList: TabItem[];
    defaultActiveTab: number | string;
    getActiveTab: (id: number | string,type: string) => void;
    type: string;
}
const Tab = ({ tabList, defaultActiveTab, getActiveTab,type }: TabProps) => {
    const [activeTab, setActiveTab] = useState<string | number>('');
    const [activeType, setActiveType] = useState<string | number>(type);
    useEffect(() => {
        setActiveTab(defaultActiveTab);
    }, [defaultActiveTab]);
    return (
        <div className='tab-main'>
            <div className='tab-list'>
                {tabList.map((item) => (
                    <div 
                        className={`tab-item ${type === 'line' ? 'line-item' : 'box-item'} ${activeTab === item.id ? 'active' : ''}`} 
                        style={item.hidden ? { display: 'none' } : undefined}
                        key={item.id} onClick={() => {
                            setActiveTab(item.id);
                            console.log(type,'type');
                            getActiveTab(item.id,type);
                        }}>
                        <span>{item.name}</span>
                        {item.time && <span className="time">{item.time}</span>}
                    </div>
                ))}
            </div>
        </div>
    )
}
export default Tab;
